// src/pages/Home.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { firestore, doc, onSnapshot } from '../firebase-config';
import LiveSpawnMap from '../components/LiveSpawnMap';
import HeatMap from '../components/HeatMap';
import ChatFeed from '../components/ChatFeed';
import './Home.css';

const Home = () => {
  const [serverStats, setServerStats] = useState(null);
  const [mapMode, setMapMode] = useState('spawn'); // 'spawn' or 'heat'

  useEffect(() => {
    const statsRef = doc(firestore, 'meta', 'serverStats');
    const unsubscribe = onSnapshot(statsRef, (doc) => {
      if (doc.exists()) {
        setServerStats(doc.data());
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="container home">
      <div className="hero">
        <h1>Welcome to CanvasMC</h1>
        <p>Make your mark.</p>
      </div>

      <div className="live-section">
        <div className="live-map-column">
          {/* <div className="map-toggle">
            <button
              className={mapMode === 'spawn' ? 'toggle-btn active' : 'toggle-btn'}
              onClick={() => setMapMode('spawn')}
            >
              Live Canvas
            </button>
            <button
              className={mapMode === 'heat' ? 'toggle-btn active' : 'toggle-btn'}
              onClick={() => setMapMode('heat')}
            >
              Heat Map
            </button>
          </div>
          
          {mapMode === 'spawn' ? <LiveSpawnMap /> : <HeatMap />} */}
          <LiveSpawnMap />
        </div>
        <div className="live-chat-column">
          <ChatFeed />
        </div>
      </div>

      <div className="stats-bar">
        {serverStats && (
          <>
            <div className="stat">
              <span className="stat-label">Online Players</span>
              <span className="stat-value">{serverStats.onlinePlayers || 0}</span>
            </div>
            <div className="stat">
              <span className="stat-label">Total Blocks</span>
              <span className="stat-value">{serverStats.totalBlocksPainted?.toLocaleString() || 0}</span>
            </div>
          </>
        )}
      </div>

      <div className="quick-links">
        <Link to="/leaderboards" className="card quick-link">
          <h3>Leaderboards</h3>
          <p>See who's painted the most blocks</p>
        </Link>
        <Link to="/map" className="card quick-link">
          <h3>Full Canvas Map</h3>
          <p>Explore the entire canvas with zoom and pan</p>
        </Link>
        <Link to="/verify" className="card quick-link">
          <h3>Verify Account</h3>
          <p>Link your Minecraft account to access features</p>
        </Link>
      </div>
    </div>
  );
};

export default Home;